export const batchHistoryInitialSortValue = {
	page: 0,
	sortBy: { desc: false, id: "date" },
	filters: undefined,
};

